
import { PropTypes } from 'prop-types';
import { DecodeHtml } from '../../utils/decodeHtml';
const EntryRequirements = ({prereqs,otherEqs,footerNote}) => {
    // const prereqs = [
    //     `
    //     SPM/O-level or equivalent
    //     Grade C in 5 subjects inclusive of Mathematics, English, Physics, 2 additional  subjects and pass in Chemistry.
    //     `,
    //     `Unified Examination Certificate (UEC)
    //     Pass UEC with grade B in 3 subjects including English, Mathematics or   Advance Mathematics, Physics or any subject and pass in
    //     Chemistry.
    //     `,
    //     `Other equivalent qualifications recognised by the Government of Malaysia.`
    // ]


    // const otherEqs = [
    //     {
    //         feeType: "Total Tuition Fees",
    //         malaysian: "RM 6,000",
    //         international: {
    //             rm: "RM 21,800",
    //             usd: "USD 5, 450"
    //         }
    //     },
    //     {
    //         feeType: "Registration Fee",
    //         malaysian: "RM 1,348",
    //         international: {
    //             rm: "RM 6,600",
    //             usd: "USD 1,650"
    //         }
    //     },
    //     {
    //         feeType: "EMGS &Application",
    //         malaysian: "",
    //         international: {
    //             rm: "RM 3,150",
    //             usd: "USD 788"
    //         }
    //     },
    // ]
    const paymentOptions = [
        "pay full in advance",
        "by monthly installments",
        "pay full 2 weeks before the  semester's final examination",
    ]
    return (
        <section className="flex  flex-col items-start gap-3 mt-5 w-full lg:w-5/6" id="whatYouLearn">
            <h2 className="text-3xl lg:text-xl font-bold">Entry Requirements</h2>
            <div className="flex flex-col gap-4 ">
                {/* <h3 className="ml-2 text-xl 2xl:text-base  font-semibold">Prerequisites</h3> */}
                {/* <ul className="flex flex-col gap-3 ">
                    {
                        prereqs.map((prereq, index) => (
                            <li key={index} className="md:text-lg 2xl:text-base font-semibold text-justify w-full  flex items-start gap-4"><span className="w-3 h-3 flex items-center justify-center mt-[5px]"><span className="w-3 h-3  rounded-full bg-black"></span></span>{prereq}</li>
                        ))
                    }
                </ul> */}
                <div className='whitespace-pre-line en' dangerouslySetInnerHTML={{ __html: prereqs }} />
                <table >
                    <thead className="otherQaulifTH">
                        <tr className="border-b text-lg lg:text-sm bg-neutral-50 rounded-tl-2xl rounded-tr-2xl ">
                            <th className="p-4   text-center py-5">Fee Type</th>
                            <th className="p-4   text-center py-5">Malaysian</th>
                            <th className="p-4   text-center py-5">International</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            otherEqs?.map((otherEq, index) => (
                                <tr key={index} className="border-b otherQaulifTR">
                                    <td className="sm:p-4 sm:py-7  otherQaulifTD" data-cell="Fee Type">{otherEq.feeType}</td>
                                    <td className="sm:p-4 sm:py-7 font-bold otherQaulifTD" data-cell="Malaysian">{otherEq.malaysian === "" ? <span className="sm:flex sm:pl-9 text-center">-</span> : otherEq.malaysian}</td>
                                    <td className="sm:p-4 sm:py-7 flex flex-col font-bold otherQaulifTD" data-cell="International">
                                        <span>{otherEq.international}</span>
                                       
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
                <div className="flex flex-col gap-3 text-lg lg:text-sm">
                    {/* <p className="font-normal ">
                        * Full & partial scholarships are available to <a className="underline text-sky-600 font-bold" href="#">APPLY</a>
                    </p>
                    <p className="font-bold">Note : Other Fee type</p>
                    <p className="">
                        <a className="underline text-sky-600 " href="#">Accommodation</a>
                        Advance Fee (if applicable) = RM250. Subject to terms and conditions. Other optional fees/charges include Medical Insurance, electricity, parking, English Short Course (ESC), Test of English Proficiency (TEP) and some student 
                        <a className="underline text-sky-600 " href="#">facilities</a>within UNITEN. 
                        </p>
                        <p className="font-bold">Flexible payment options are available ;  
                         <ol className="flex flex-wrap gap-x-10 gap-y-3 pl-4 mt-2 w-full list-[lower-roman]">
                            {
                                paymentOptions.map((paymentOption, index) => (
                                    <li key={index} className="text-sm 2xl:text-base font-semibold  gap-4">{paymentOption}</li>
                                ))
                            }
                         </ol>
                        </p> */}
                        {
                            DecodeHtml({html:footerNote})
                        }
                </div>
            </div>
        </section>
    )
}
EntryRequirements.propTypes = {
    prereqs: PropTypes.string,
    otherEqs: PropTypes.array,
    footerNote: PropTypes.string
}
export default EntryRequirements